// getters
const adminCarnets = state => state.adminCarnets

export default {
  adminCarnets
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/carnets/getters.js